import { useState, useCallback } from "react";
import { BuildReportConfig } from "../services/reports/BuildReportsConfig";
import { ReportCategory } from "../enums/Reports";
import { useApp } from "../store/AppProvider";
import { ReportItem } from "../pages/ReportsList/reportsConfig";
import { CompassError } from "../types/errorTypes";

interface ReportConfigResult {
  fetchReportParameters: () => Promise<void>;
  reportItem: ReportItem | null;
  error: CompassError | null;
  isLoading: boolean;
}

export const useReportConfig = (
  reportType: ReportCategory
): ReportConfigResult => {
  const [reportItem, setReportItem] = useState<ReportItem | null>(null);
  const [error, setError] = useState<CompassError | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { app } = useApp();
  const authToken = app.authorisation.token;

  const fetchReportParameters = useCallback(async () => {
    setIsLoading(true);
    const config = new BuildReportConfig(reportType, authToken);
    try {
      const parameters = await config.buildParameters();
      setReportItem(parameters);
    } catch (e) {
      setError(e as CompassError);
    } finally {
      setIsLoading(false);
    }
  }, [reportType, authToken]);

  return { reportItem, error, isLoading, fetchReportParameters };
};

export default useReportConfig;
